<!--HEADER-->
<div class="additional-booking__header row" id="additionalBookingHeader">
  <div class="additional-booking__header-col col-12">
    <h3 class="additional-booking__intro"
        *appApplyIfNotEmpty="translationService.getTranslation('additionalBooking_intro')"
        [innerHTML]="translationService.getTranslation('additionalBooking_intro')"></h3>
  </div>
  <div class="additional-booking__header-col col-12">
    <p class="additional-booking__description"
       *appApplyIfNotEmpty="translationService.getTranslation('additionalBooking_description')"
       [innerHTML]="translationService.getTranslation('additionalBooking_description')"></p>
  </div>
</div>

<div class="additional-booking__content row">
  <div class="additional-booking__content-col col-12">

    <div class="additional-booking__spinner" style="text-align: center;" *ngIf="isStateUnknown">
      <app-loading-spinner></app-loading-spinner>
    </div>

    <ng-container *ngIf="isGuest">
      <div class="additional-booking__registered-hint" *ngIf="justRegistered"
           [innerHTML]="translationService.getTranslation('additionalBooking_registered_hint')"></div>
      <p class="additional-booking__guest-description"
         [innerHTML]="translationService.getTranslation('additionalBooking_guest_description')"></p>
      <div class="additional-booking__guest-actions">
        <button mat-raised-button color="primary"
                class="additional-booking__login-btn"
                (click)="goToLogin()"
                [innerHTML]="translationService.getTranslation('additionalBooking_button_login')"></button>
        <button mat-flat-button
                class="additional-booking__identification-btn btn btn-secondary"
                (click)="goToIdentification()"
                [innerHTML]="translationService.getTranslation('additionalBooking_button_identification')"></button>
      </div>
    </ng-container>

    <div class="additional-booking__checking" *ngIf="isAuthenticated && isLoading">
      <div class="additional-booking__spinner" style="text-align: center;">
        <app-loading-spinner></app-loading-spinner>
      </div>
      <p class="additional-booking__checking-text"
         [innerHTML]="translationService.getTranslation('additionalBooking_checking_eligibility')"></p>
    </div>

    <div class="additional-booking__checking" *ngIf="isAuthenticated && !isLoading">
      <div class="additional-booking__errors" style="text-align: center;">
        <app-general-errors [errors]="errors"></app-general-errors>
      </div>

      <!-- Je Hauptabo die zubuchbaren Kombi-Werbeschlüssel: ein Button je Angebot, bei mehreren
           zusätzlich "Alle buchen" -->
      <app-subscription-card *ngFor="let qualified of qualifiedSubscriptions"
                             class="additional-booking__subscription"
                             [subscription]="qualified.subscription">
        <!-- Gleiches Raster wie die Abodaten der Karte (row + col-12), damit das Label buendig
             unter dem Titel steht -->
        <div class="additional-booking__offers row mx-3 mb-3">
          <div class="col-12">
            <mat-divider class="additional-booking__offers-divider"></mat-divider>
            <p class="additional-booking__offers-label"
               [innerHTML]="translationService.getTranslation('additionalBooking_offers_label')"></p>
            <div class="additional-booking__offer-list">
              <div class="additional-booking__offer" *ngFor="let offer of qualified.bookableCombiOffers">
                <span class="additional-booking__offer-description">{{ offer.description }}</span>
                <button mat-flat-button class="additional-booking__book-btn btn btn-secondary"
                        (click)="bookOffers(qualified, [offer])"
                        [innerHTML]="translationService.getTranslation('additionalBooking_button_book')"></button>
              </div>
            </div>
            <div class="additional-booking__book-all" *ngIf="qualified.bookableCombiOffers.length > 1">
              <button mat-flat-button class="additional-booking__book-all-btn btn btn-secondary"
                      (click)="bookOffers(qualified, qualified.bookableCombiOffers)"
                      [innerHTML]="translationService.getTranslation('additionalBooking_button_bookAll')"></button>
            </div>
          </div>
        </div>
      </app-subscription-card>

      <!-- Nichts zuzubuchen: Der Hinweis nennt den Grund, der Button führt in die Abos -->
      <div class="additional-booking__no-booking" *ngIf="hasNoEligibleSubscription">
        <p class="additional-booking__no-booking-text"
           [innerHTML]="translationService.getTranslation('additionalBooking_noEligibleSubscriptions')"></p>
        <div class="additional-booking__no-booking-actions">
          <button mat-raised-button color="primary"
                  class="additional-booking__subscriptions-btn" (click)="goToSubscriptions()"
                  [innerHTML]="translationService.getTranslation('additionalBooking_button_toSubscriptions')"></button>
        </div>
      </div>
    </div>
  </div>
</div>
